import PageHeader from "../../components/ui/PageHeader";

/**
 * Legacy adapter (UI-1): a page wrapper with the canonical PageHeader. The
 * `eyebrow` prop (HRPageShell passes "HR") is accepted and no longer shown;
 * the breadcrumb says where the page lives.
 */
export default function WorkspacePageShell({
  title,
  subtitle,
  actions = null,
  // eslint-disable-next-line no-unused-vars
  eyebrow,
  children,
}) {
  return (
    <div className="operations-page">
      <PageHeader title={title} description={subtitle} actions={actions} />
      {children}
    </div>
  );
}
